import theme from './theme/th_TH';
import profile from './profile/th_TH';
import member from './member/th_TH';
import organization from './organization/th_TH';
import console from './console/th_TH';
import aws from './aws/th_TH';
import activity from './activity/th_TH';

export default {
  ...theme,
  ...profile,
  ...console,
  ...organization,
  ...member,
  ...aws,
  ...activity,
};
